import React, { useEffect } from 'react'
import FAQ from './FAQ'
import { Link } from "react-router-dom";
import { Button } from 'antd';

export default function Narration(props) {
    useEffect(() => {
        document.title = "Vabis' Literature Services - Literature Proofreading - Audiobook Narration for Picture Books";
        window.scrollTo(0, 0);
    }, [])

    return (
        <div className="App">
            <div className="promotion">&#128218;&#128218;  CLAIM 10 PERCENT OFF NOW USING CODE: <b>10OFF</b> , USE IT ON PAYMENT PAGE  &#128218;&#128218;</div>
            <div className="header-wrapper">
                <img
                    src={'/images/shutterstock_1713485986_600.jpg'}
                    srcSet={`/images/shutterstock_1713485986_1200.jpg 4000w`}
                    alt="Audiobooks"
                    style={{float: 'left', width: '100%'}}
                />

                <div className="header-text">
                    <header>
                        <h1>Audiobook Narration for Picture Books</h1>
                    </header>
                    <p>
                        I have done a Grade 5 reading exam with The London Academy of Music and Dramatic Arts (LAMDA) and thus I am a well qualified narrator. Also, whilst I was a teacher, I would love to read stories to children aged between 0- 7 years. I have first-hand experience to know what children really like whilst narrating. Let me be part of narrating your picture books for an affordable price. I am also happy to narrate picture books for YouTube channels or a series of books on a regular basis (Please <a href='mailto:vabisliteratureservices@gmail.com'>email</a> me so we can discuss discounts).
                    </p>
                    <Link to="/request?service=narration"><Button type="primary">Request for audiobook narration</Button></Link>
                </div>
            </div>

            <div className="content-wrapper">
                <FAQ topic='narration' />
                <FAQ topic='general' />
            </div>
        </div>
    )
}
